import { Component } from '@angular/core';

@Component({
  templateUrl: './primitives.html'  
})
export class PrimitivesComponent { 

    constructor() { }

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/primitives/primitives-component.ts